import { render, staticRenderFns } from "./FormBuilderUsersData.vue?vue&type=template&id=56ed67c6&scoped=true"
import script from "./FormBuilderUsersData.vue?vue&type=script&lang=js"
export * from "./FormBuilderUsersData.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderUsersData.vue?vue&type=style&index=0&id=56ed67c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed67c6",
  null
  
)

export default component.exports